export var DIALOG_WIDTH = 310;
export var DIALOG_WIDTH_WIDER = 325;
export var VIEW_HEIGHT = 305;